import React from 'react'
import { Link } from 'react-router-dom'
import { IoDocumentTextOutline } from 'react-icons/io5'

const resolvedTopics = [
    { title: 'Dashboard', path: '/GRC/help-center/dashboard/dashboard' },
    { title: 'Organizational Chart', path: '/GRC/help-center/governance/organizational-chart' },
    { title: 'Risk Register', path: '/GRC/help-center/risk/risk-register' },
    { title: 'Risk Heat Map', path: '/GRC/help-center/risk/risk-heat-map' },
    { title: 'Compliance', path: '/GRC/help-center/compliance/compliance' },
    { title: 'Calendar', path: '/GRC/help-center/calendar/calendar' },
    { title: 'Tools', path: '/GRC/help-center/tools/tools' }
]

const ResolvedTopics = ({ disabled = false }) => {
    return (
        <div className={`p-4 ${disabled && 'opacity-50 pointer-events-none'}`}>
            <h2 className={`text-xl font-semibold mb-14 ${disabled && 'text-grey'}`}>Most Resolved Topics</h2>
            <ul className="space-y-4">
                {resolvedTopics.map((topic, index) => (
                    <li key={index} className={`flex gap-4 ${disabled && 'text-grey'}`}>
                        <IoDocumentTextOutline className="flex-shrink-0 text-2xl" />
                        <Link to={topic.path} className="hover:underline">
                            {topic.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default ResolvedTopics
